module.exports = __webpack_public_path__ + "static/tv-mockup2-5a0a2d2bf0167623b41d5a31bd5f41fc.png";